import IAppLogger from '@app/lib/IAppLogger';
import DiagnosticsModule from '@modules/DiagnosticsModule';
import { audioDevicesState } from '@modules/SoftPhoneModule/audioDevicesState';
import {
  ErrorCategory,
  MicMonitorFailedPayload,
} from '@modules/SoftPhoneModule/types';
import { webPhoneEventNames } from '@modules/SoftPhoneModule/constants/events';

function messageForMicMonitorFailure(category: ErrorCategory): string {
  switch (category) {
    case 'permission_denied':
      return 'Microphone access was denied. Allow microphone access to test your microphone.';
    case 'device_not_found':
      return 'The selected microphone was not found. Try choosing another device.';
    case 'device_in_use':
      return 'The microphone is in use by another application.';
    case 'media_api_unavailable':
      return 'Audio is not available in this browser or session.';
    case 'other':
      return 'Could not start microphone monitor. Try again or select a different device.';
  }
}

/**
 * Handles `webphone:mic-monitor-failed` when the MFE cannot start mic monitoring.
 */
const handleMicMonitorFailed = (
  payload: MicMonitorFailedPayload,
  logger: IAppLogger,
): void => {
  const { errorCategory, errorName, errorMessage } = payload;

  audioDevicesState.isTestingMicrophone = false;

  logger.error(webPhoneEventNames.micMonitorFailed, {
    errorCategory,
    errorName,
    errorMessage,
  });

  DiagnosticsModule.reportUserError(
    messageForMicMonitorFailure(errorCategory),
    {
      priority: 'passive',
    },
  );
};

export default handleMicMonitorFailed;
